"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONTableCellMarginsConverter = void 0;
var table_base_structures_1 = require("../../../tables/secondary-structures/table-base-structures");
var json_table_structures_enums_1 = require("../../enums/table/json-table-structures-enums");
var json_table_unit_converter_1 = require("./json-table-unit-converter");
var JSONTableCellMarginsConverter = (function () {
    function JSONTableCellMarginsConverter() {
    }
    JSONTableCellMarginsConverter.convertFromJSON = function (obj) {
        var result = new table_base_structures_1.TableCellMargins();
        result.top = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertFromJSON(obj[json_table_structures_enums_1.JSONTableCellMarginsProperty.Top]);
        result.left = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertFromJSON(obj[json_table_structures_enums_1.JSONTableCellMarginsProperty.Left]);
        result.right = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertFromJSON(obj[json_table_structures_enums_1.JSONTableCellMarginsProperty.Right]);
        result.bottom = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertFromJSON(obj[json_table_structures_enums_1.JSONTableCellMarginsProperty.Bottom]);
        return result;
    };
    JSONTableCellMarginsConverter.convertToJSON = function (source) {
        var result = {};
        result[json_table_structures_enums_1.JSONTableCellMarginsProperty.Top] = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertToJSON(source.top);
        result[json_table_structures_enums_1.JSONTableCellMarginsProperty.Left] = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertToJSON(source.left);
        result[json_table_structures_enums_1.JSONTableCellMarginsProperty.Right] = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertToJSON(source.right);
        result[json_table_structures_enums_1.JSONTableCellMarginsProperty.Bottom] = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertToJSON(source.bottom);
        return result;
    };
    return JSONTableCellMarginsConverter;
}());
exports.JSONTableCellMarginsConverter = JSONTableCellMarginsConverter;
